import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Clock, Mail } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-32 px-6 bg-brand-charcoal border-t border-brand-gold/10" data-id="element-31">
      <div className="max-w-6xl mx-auto" data-id="element-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-33">
          {/* Hours & Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-34">
            <h2 className="font-serif text-4xl md:text-5xl text-brand-offwhite mb-10" data-id="element-35">
              Visit Us
            </h2>

            <div className="space-y-8" data-id="element-36">
              <div className="flex items-start space-x-4" data-id="element-37">
                <MapPin className="text-brand-gold mt-1 flex-shrink-0" size={24} data-id="element-38" />
                <div data-id="element-39">
                  <h4 className="font-serif text-xl text-brand-gold mb-2" data-id="element-40">
                    Location
                  </h4>
                  <p className="text-brand-offwhite/80" data-id="element-41">
                    211 Broadway
                    <br data-id="element-42" />
                    Paducah, KY 42001
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-43">
                <Clock className="text-brand-gold mt-1 flex-shrink-0" size={24} data-id="element-44" />
                <div data-id="element-45">
                  <h4 className="font-serif text-xl text-brand-gold mb-2" data-id="element-46">
                    Hours
                  </h4>
                  <ul className="text-brand-offwhite/80 space-y-2" data-id="element-47">
                    <li className="flex justify-between w-56" data-id="element-48">
                      <span data-id="element-49">Mon - Thu</span> <span data-id="element-50">4:00 PM - 9:00 PM</span>
                    </li>
                    <li className="flex justify-between w-56" data-id="element-51">
                      <span data-id="element-52">Fri - Sat</span> <span data-id="element-53">4:00 PM - 10:00 PM</span>
                    </li>
                    <li className="flex justify-between w-56 text-brand-offwhite/50" data-id="element-54">
                      <span data-id="element-55">Sunday</span> <span data-id="element-56">Closed</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-57">
                <Phone className="text-brand-gold mt-1 flex-shrink-0" size={24} data-id="element-58" />
                <div data-id="element-59">
                  <h4 className="font-serif text-xl text-brand-gold mb-2" data-id="element-60">
                    Contact
                  </h4>
                  <a href="tel:2709331707" className="text-brand-offwhite/80 hover:text-brand-gold transition-colors duration-300 block" data-id="element-61">
                    (270) 933-1707
                  </a>
                  <a href="mailto:CheahFamilyFoods@gmail.com" className="text-brand-offwhite/80 hover:text-brand-gold transition-colors duration-300 block mt-2 break-all" data-id="element-62">
                    CheahFamilyFoods@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Reservation CTA */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-brand-black p-10 md:p-14 border border-brand-gold/20 flex flex-col justify-center items-center text-center relative overflow-hidden" data-id="element-63">
            <div className="absolute inset-0 bg-[length:24px_24px] bg-subtle-pattern opacity-10" data-id="element-64"></div>

            <div className="relative z-10" data-id="element-65">
              <h3 className="font-serif text-3xl text-brand-gold mb-4" data-id="element-66">
                Reservations
              </h3>
              <p className="text-brand-offwhite/70 mb-10 max-w-sm mx-auto" data-id="element-67">
                Join us for an unforgettable dining experience. We recommend
                booking in advance to secure your table.
              </p>

              <button className="w-full sm:w-auto px-10 py-4 bg-brand-gold text-brand-black font-semibold tracking-widest uppercase hover:bg-brand-offwhite transition-colors duration-300" data-id="element-68">
                Book a Table
              </button>

              <p className="mt-6 text-sm text-brand-offwhite/40 italic" data-id="element-69">
                For parties of 8 or more, please call us directly.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}